import * as React from 'react';
import { ToDoDescriptor } from './types';
import { ToDoGroupItem } from './components/ToDoGroupItem';
import { ToDoLinkItem } from './components/ToDoLinkItem';

export const renderDescriptor = (descriptor: ToDoDescriptor) =>
  descriptor.variant === 'group' ? (
    <ToDoGroupItem key={descriptor.id} descriptor={descriptor} />
  ) : (
    <ToDoLinkItem key={descriptor.id} descriptor={descriptor} />
  );
